var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
    fill: "#8EB4C3",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1076 56.18C77.0651 38.3388 67.5113 32.4725 66.4826 30.2313C65.3576 28.65 64.2176 25.8375 64.2176 25.8375C64.1988 25.79 64.1688 25.7062 64.1338 25.625C64.0176 27.2062 63.9576 27.8162 62.4626 29.4112C60.1476 31.2212 48.2701 41.1875 47.3038 61.4575C46.4026 80.3625 60.9601 91.6275 62.9288 93.0638L63.1526 93.2225V93.2087C63.1651 93.3037 63.7775 97.7087 64.2076 102.376H65.7501C66.112 99.0769 66.6545 95.7999 67.3751 92.56L67.5001 92.4788C68.3807 91.8473 69.2203 91.1605 70.0138 90.4225L70.1038 90.3412C74.2888 86.475 81.8125 77.5325 81.7388 63.275C81.7232 60.8967 81.5121 58.5237 81.1076 56.18ZM64.0438 82.39C64.0438 82.39 64.0438 55.875 64.9188 55.88C65.6013 55.88 66.4851 90.0813 66.4851 90.0813C65.2701 89.935 64.0438 84.4525 64.0438 82.39Z",
    fill: "#BBE3E1",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.c941ab358ee0fddd858b299903f39cff.svg";
export { ForwardRef as ReactComponent };